import React from "react";
import { Box, Button, Flex } from "@chakra-ui/react";

import { PaginationProps } from "../../interface/interface";

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <Flex alignItems="center" justifyContent="center" gap="3rem" mt={4}>
      <Button onClick={handlePrevPage} disabled={currentPage === 1}>
        Previous
      </Button>
      <Box mx={2} fontWeight="bold" fontSize="2xl">
        {currentPage}
      </Box>
      <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
        Next
      </Button>
    </Flex>
  );
};

export { Pagination };
